/* eslint-disable no-unused-vars */
import React, { memo } from "react"

type SwitcherProps = {
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  checked?: boolean
  id?: string
  name?: string
}

type RefType = HTMLInputElement

const Switcher = React.forwardRef<RefType, SwitcherProps>((props, ref) => {
  const { onChange, checked, id, name } = props
  return (
    <label className="switcher">
      <input ref={ref} type="checkbox" id={id} name={name} onChange={onChange} checked={checked} />
      <span className="switcher_slider"></span>
    </label>
  )
})
export default memo(Switcher)
